var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.441 15.3134L15.126 18.0029L12.4395 20.6932L13.5015 21.7529L17.2515 18.0029L13.5015 14.2529L12.441 15.3134Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.691 15.3134L20.376 18.0029L17.6895 20.6932L18.7515 21.7529L22.5015 18.0029L18.7515 14.2529L17.691 15.3134Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3493 5.25L12 10.338L4.6515 5.25H19.3493ZM10.5 17.25H3L2.99775 5.9295L11.5732 11.8665C11.7015 11.9558 11.8507 12 12 12C12.15 12 12.2985 11.9558 12.4275 11.8665L21.0007 5.93175L21 12.75H22.5V5.25C22.5 4.42275 21.8272 3.75 21 3.75H3C2.1735 3.75 1.5 4.4205 1.5 5.247V17.25C1.5 18.0773 2.1735 18.75 3 18.75H10.5V17.25Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.143f7bc864e91551ec200524137e687d.svg";
export { ForwardRef as ReactComponent };